import React from 'react';
import { subscription } from './Datatype';

interface props {
  subscriptiondata: subscription[];
  changestatus?: (item: subscription, status: string) => void;
  openedit?: (item: subscription) => void;
}

// AdminSubscriptionTable: display-only grid of subscriptions with action dropdown
const AdminSubscriptionTable: React.FC<props> = ({ subscriptiondata, changestatus, openedit }) => {
  const handleaction = (item: subscription, action: string) => {
    if (action === 'edit' && openedit) {
      openedit(item);
    } else if (changestatus) {
      changestatus(item, action);
    }
  };

  const rows = subscriptiondata.map((item, i) => (
    <tr key={item._id || i}>
      <td style={{ width: '60px' }}>
        <select
          className="action-select"
          value=""
          onChange={(e) => handleaction(item, e.target.value)}
        >
          <option value="" disabled>{i + 1}</option>
          <option value="edit">edit</option>
          <option value="active">set active</option>
          <option value="pending">set pending</option>
        </select>
      </td>
      <td>{item._id}</td>
      <td><strong>{item.name}</strong></td>
      <td>{item.phone}</td>
      <td>{item.address}{item.pin ? `, ${item.pin}` : ''}</td>
      <td>
        {item.items && item.items.map((it: any, idx: number) => (
          <div key={idx}>{it.quantity} x {it.name || it.productid}</div>
        ))}
      </td>
      <td>{item.frequency} ({item.preferredday})</td>
      <td><span className={`status-badge ${item.status}`}>{item.status}</span></td>
      <td>{item.enddate || '-'}</td>
      <td>{item.gatewaytokenid || '-'}</td>
    </tr>
  ));

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>id</th>
          <th>customer</th>
          <th>phone</th>
          <th>address</th>
          <th>items</th>
          <th>frequency</th>
          <th>status</th>
          <th>next billing date</th>
          <th>token id</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={8} style={{ textAlign: 'center', padding: '16px' }}>No subscriptions found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default AdminSubscriptionTable;
